import { useAuthLoggedIn } from "../../context/AuthProvider";
import { UserRole } from "../../interfaces/UserRole";
import React from "react";
const VeterinaryHome = React.lazy(
	() => import(/* webpackChunkName: "veterinary-home" */ "./VeterinaryHome")
);
const CustomerHome = React.lazy(
	() => import(/* webpackChunkName: "customer-home" */ "./CustomerHome")
);
const PackerHome = React.lazy(
	() => import(/* webpackChunkName: "packer-home" */ "./PackerHome")
);
const SlaughterHouseHome = React.lazy(
	() =>
		import(
			/* webpackChunkName: "slaughter-house-home" */ "./SlaughterHouseHome"
		)
);

export function Home() {
	const {
		user: { role },
	} = useAuthLoggedIn();

	switch (role) {
		case UserRole.Veterinary:
			return <VeterinaryHome />;
		case UserRole.Packer:
			return <PackerHome />;
		case UserRole.SlaughterHouse:
			return <SlaughterHouseHome />;
		default:
			return <CustomerHome />;
	}
}
